var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "root",
      staticClass: "draggable",
      style: {
        top: _vm.useBottom ? undefined : _vm.y + "mm",
        bottom: _vm.useBottom ? _vm.y + "mm" : undefined,
        left: _vm.x + "mm",
      },
      on: { mousedown: _vm.mouseDown },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }